//system
import { Component, ViewChild, ElementRef, HostListener, OnInit, OnDestroy, Renderer2, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta, DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { LogService } from 'src/app/services/common/log.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FacilityService } from 'src/app/services/facility.service';
import { MetaService } from 'src/app/services/meta.service';
import { InviteCodeService } from 'src/app/services/invite-code.service';
import { ShortLinkService } from 'src/app/services/short-link.service';
import { MemberService } from 'src/app/services/member.service';

//interfaces
import { MemberModel, MyDrop, Purchase } from 'src/app/models/member';
import { TermUnit, InviteCodeType, DiscountUnit, CurrencyCategoryState, CurrencyMenuPackState } from 'src/app/models/enums';
import { CategoryMenuPack, CurrencyMeta, MenuPack } from 'src/app/models/meta';

import { InviteCode, InviteCodeRedeemRequest, ShortLink, ShortLinkMeta } from 'src/app/models/invite-code';

//components
import { AuthBaseComponent } from 'src/app/components/auth-base/auth-base.component';
import { LoginComponent } from 'src/app/components/df-login/df-login.component';
import { BenefitsComponent } from 'src/app/components/popups/my-drop/benefits/benefits.component';
import { ChoosePlanComponent } from 'src/app/components/popups/my-drop/choose-plan/choose-plan.component';

//utils
import { Utils } from 'src/app/services/common/utils';
import { Location } from 'src/app/models/common-models';
import { StripeCheckoutComponent } from 'src/app/components/popups/my-drop/stripe-checkout/stripe-checkout.component';
import { FacilityConfig, PromoBannerStrip } from 'src/environments/environment.interface';
import { EnvironmentService } from 'src/app/services/environment.service';
import { CheckoutComponentFactoryService } from 'src/app/services/checkoutComponentFactoryService';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import {
  isSubscriptionMenuPackActive,
  shouldOpenCheckoutForMenuPack,
} from './purchase-active-pack.helpers';

@Component({
  selector: 'df-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent extends AuthBaseComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('login') loginPopup!: LoginComponent;
  bannerObj: PromoBannerStrip | null;
  currentMember!: any;
  member: MemberModel;
  memberId: number = 0;
  activeScrollCategoryId: number = 1;
  selected: boolean = false;

  currencyMeta!: CurrencyMeta;
  myDrop!: MyDrop;

  menuPacks!: MenuPack[];
  filteredMenuPacks!: MenuPack[];

  categoryMenuPacks!: CategoryMenuPack[];
  locations: Location[] = [];

  redirectTo: string = "";
  currencyId: number = 0;

  inviteCode!: InviteCode;
  inviteCodeStr: string = "";
  shortCode: string = "";
  shortLink!: ShortLink;
  locationId: number = 1;
  loginTitle: string = "Log into your account";
  loginDescription: string = "Please enter your mobile number to verify or create an account.";
  currentMemberLocationId: number = 0;
  checkoutComponent: any;
  settings: FacilityConfig;
  phoneNumber: string = '';
  selectedItemId: number = 0;

  bodyHeight: number = 500;
  /** Prevents stacking checkout modals while one is already open. */
  private checkoutModalOpen = false;

  constructor(
    private router: Router
    , private logService: LogService
    , private alertService: AlertService
    , private metaService: MetaService
    , private activeRoute: ActivatedRoute
    , private authService: AuthService
    , private facilityService: FacilityService
    , private modalService: NgbModal
    , private sanitizer: DomSanitizer
    , private el: ElementRef
    , private inviteCodeService: InviteCodeService
    , private shortLinkService: ShortLinkService
    , private memberService: MemberService
    , private _environmentService: EnvironmentService
    , private CheckoutComponentFactoryService: CheckoutComponentFactoryService
    , private localStorageService: LocalStorageService
  ) 
  { 
    super(router, logService, alertService, facilityService);
    this.checkoutComponent = this.CheckoutComponentFactoryService.getCheckoutComponent();
    this.settings = this._environmentService.getFacilityConfig();
    this.phoneNumber = this.localStorageService.getProp('df-auth-key', 'PhoneNumber');
  }

    sendBodyHeight() {
    var bodyH = this.el.nativeElement.ownerDocument.body.offsetHeight;
    if(this.bodyHeight != bodyH)
    {
      this.bodyHeight = bodyH;
      window.parent.postMessage({ frameHeight: this.bodyHeight }, '*');
    }
  }

  ngAfterViewInit(): void {
    // Send message to parent frame with iframe height
    window.parent.postMessage({ frameHeight: this.sendBodyHeight() }, '*');
  }

  override async ngOnInit() {
    await super.ngOnInit();
    this.locationId = this.activeRoute.snapshot.params['locationId'] || 0;
    this.inviteCodeStr = this.activeRoute.snapshot.queryParams['invite_code'];
    this.shortCode = this.activeRoute.snapshot.queryParams['short_code'];

    // Get the redirectTo query parameter
    this.redirectTo = this.activeRoute.snapshot.queryParams['redirectTo'] || '';
    this.currencyId = this.activeRoute.snapshot.queryParams['currencyId'] || 0;
    this.selectedItemId = this.activeRoute.snapshot.queryParams['selectedItemId'] || 0;
    this.selectedItemId = parseInt(this.selectedItemId as any);

    this.currentMember = this.authService.getLoggedInMember();
    this.memberId = this.currentMember?.Id || 0;

    if(this.memberId == 0 && this.locationId == 0)
    {
      this.bannerObj = this._environmentService.getPromoBanner('pricingPage');

      if(!Utils.isNullOrEmpty(this.inviteCodeStr))
      {
        this.inviteCode = await this.inviteCodeService.getInviteCode(this.inviteCodeStr);
        if(this.inviteCode.CodeType == InviteCodeType.ReEngagementFreeCredit)
        {
          this.loginTitle = "Free Credits!";
          this.loginDescription = "Please login to apply it to your account.";
        }
        this.loginPopup.open(null, this.phoneNumber, 'phone', this.redirectTo);
      }

      if(!Utils.isNullOrEmpty(this.shortCode))
      {
        this.loginPopup.open(null, this.phoneNumber, 'phone', this.redirectTo);
      }
    }

    this.locations = await this.facilityService.getLocations();

    if(this.memberId > 0)
    {
      this.member = await this.memberService.getMember();
      this.myDrop = await this.memberService.getMyDrop(this.memberId);
    }

    this.locationId = this.resolveInitialLocationId();
    this.persistSelectedLocation();

    if(this.memberId > 0 && !Utils.isNullOrEmpty(this.inviteCodeStr))
    {
      const redeemRequest : InviteCodeRedeemRequest = {
        MemberId : this.currentMember.Id,
        Code: this.inviteCodeStr
      };

      this.inviteCodeService.redeemInviteCode(redeemRequest).subscribe((data: InviteCode | string) => {
        if(typeof(data) === 'string')
        {
          this.alertService.error(data);
          return;
        } else {
          this.inviteCode = data;
          this.alertService.info("Code has been redeemed successfully.");
          this.logService.debug("this.inviteCode", this.inviteCode);
        }
      });

      this.inviteCode = await this.inviteCodeService.getInviteCode(this.inviteCodeStr);
      if(this.inviteCode != null && this.inviteCode.CodeType == InviteCodeType.PaymentLink)
      {
        // Open after currency meta is loaded (below) — not a fixed delay.
        this.selected = true;
        this.selectedItemId = this.inviteCode.IntentId;
      }
    }

    if(this.memberId > 0 && !Utils.isNullOrEmpty(this.shortCode))
    {
      this.shortLink = await this.shortLinkService.getShortLinkDetailsByCode(this.shortCode);
      if(this.shortLink != null && typeof(this.shortLink) != "undefined")
      {
        var metaData: ShortLinkMeta | undefined = this.getShortLinkMetaDataByKey(this.shortLink, "MenuPackId");
        if(metaData != null && typeof(metaData) != "undefined")
        {
          // Open after currency meta is loaded (below) — not a fixed delay.
          this.selected = true;
          this.selectedItemId = parseInt(metaData.Value ?? "0", 10);
        }
        
      }
    }

    if(this.locationId > 0 && this.memberId == 0)
    {
      this.currencyMeta = await this.metaService.getCurrencyMetaByLocation(this.locationId);
    } else {
      this.currencyMeta = await this.metaService.getCurrencyMetaByMember(this.memberId);
    }
    this.buildCategoryMenuPacks();

    setTimeout(() => {
      this.sendBodyHeight();
    }, 1000);

    // Payment-link / short_code / selectedItemId all open here once packs are ready.
    if(this.selectedItemId > 0)
    {
      this.openCheckoutPopup(this.selectedItemId);
    }
  }

  private buildCategoryMenuPacks(): void {
    this.currencyMeta.Categories.sort((a, b) => a.Order - b.Order);
    this.currencyMeta.Categories = this.currencyMeta.Categories.filter(
      (m) => m.Slug !== 'store_credits' && !Utils.isPauseSubscriptionCategory(m)
    );

    const filteredMenuPackIds = this.currencyMeta.DiscountMenuPacks.map(dmp => dmp.MenuPackId);

    this.menuPacks = [];
    this.filteredMenuPacks = [];

    for (const menu of this.currencyMeta.Menus) {
      for (const menuPack of menu.MenuPacks) {
        this.menuPacks.push(menuPack);
        if (
          filteredMenuPackIds.includes(menuPack.Id) &&
          menuPack.ParentId == 0 &&
          !Utils.isPauseSubscriptionMenuPack(menuPack)
        ) {
          this.filteredMenuPacks.push(menuPack);
        }
      }
    }

    this.categoryMenuPacks = [];
    for (const menuPack of this.filteredMenuPacks) {
      var discountMenuPack = this.currencyMeta.DiscountMenuPacks.find(c => c.MenuPackId === menuPack.Id);
      if(discountMenuPack)
      {
        menuPack.Order = discountMenuPack.Order;
        var decoyPrice = menuPack.DecoyPrice >= menuPack.Price ? menuPack.DecoyPrice : menuPack.Price;
        menuPack.DecoyPrice = decoyPrice;
        switch (discountMenuPack.DiscountUnit) {
          case DiscountUnit.Percentage:
            menuPack.Price = decoyPrice - (decoyPrice * discountMenuPack.DiscountNumber / 100);
            break;
          case DiscountUnit.Amount:
            menuPack.Price = decoyPrice - discountMenuPack.DiscountNumber;
            break;
          default:
            break;
        }
      }

      if (!menuPack.CategoryId) {
        continue;
      }

      const category = this.currencyMeta.Categories.find(
        (cat) => cat.Id === menuPack.CategoryId && cat.State === CurrencyCategoryState.Active
      );
      if (!category) {
        continue;
      }

      let foundCategoryMenuPack = this.categoryMenuPacks.find((cmp) => cmp.Category.Id === category.Id);
      if (!foundCategoryMenuPack) {
        foundCategoryMenuPack = { Category: category, MenuPacks: [] };
        this.categoryMenuPacks.push(foundCategoryMenuPack);
      }

      const existingMenuPack = foundCategoryMenuPack.MenuPacks.find((mp) => mp.Id === menuPack.Id);
      if (!existingMenuPack) {
        if (this.currencyId === 0 || this.currencyId === menuPack.CurrencyId) {
          foundCategoryMenuPack.MenuPacks.push(menuPack);
        }
      }
    }
    this.categoryMenuPacks.sort((a, b) => a.Category.Order - b.Category.Order);

    for (const category of this.categoryMenuPacks) {
      category.MenuPacks.sort((a, b) => a.Order - b.Order);
    }

    if (this.categoryMenuPacks.length > 0) {
      this.activeScrollCategoryId = this.categoryMenuPacks[0].Category.Id;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.sendBodyHeight();
    var scrollPosition: number = window.scrollY || window.pageYOffset;
    scrollPosition = scrollPosition + 65;
    const sections = document.querySelectorAll('.category-wraper');
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i] as HTMLElement;
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.clientHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        this.activeScrollCategoryId = parseInt(section.id.replace("category-", ""));
        break;
      }
    }
  }

  goToCategory(categoryId: number)
  {
    const element = document.getElementById("category-"+categoryId);
    if (element) {
      const elementOffsetTop = element.offsetTop;
      window.scrollTo({
        top: elementOffsetTop - 65,
        behavior: 'smooth', // Add smooth scrolling behavior
      });
      this.activeScrollCategoryId = categoryId;
    }
  }

  hasMenuPacks(categoryId: number): boolean {
    // return Array.isArray(categoryMenuPack?.MenuPacks) && categoryMenuPack.MenuPacks.some((c: any) => c && c.State === 1);
    const category = this.categoryMenuPacks.find(c => c.Category.Id === categoryId);
    return category ? category.MenuPacks.filter((c: MenuPack) => c && c.State === CurrencyMenuPackState.Active).length > 0 : false;
  }

  openStripeCheckoutPopup(itemId: number = 0) {
    this.selected = true;
    if(itemId == 0)
      return;

    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === itemId);
    if (menuPack) {
      setTimeout(() => {
        //open class map popup
        const modalRef = this.modalService.open(StripeCheckoutComponent, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'xl',
          centered: true,
          // windowClass: 'checkout-popup-wrapper',
          // modalDialogClass: 'checkout-popup',
          fullscreen: window.innerWidth <= 768,
        });

        modalRef.componentInstance.productName = menuPack.Name;
        modalRef.componentInstance.productDescription = menuPack.UpgradeDescription;
        modalRef.componentInstance.productImage = this.getPackImage(itemId);
        modalRef.componentInstance.productPrice = menuPack.Price;
  
        modalRef.result.then((result: boolean) => {
          if (result) {
            this.logService.debug("purchase details:", result);
            // location.href = "/buy/1";
          }
        });
        this.selected = false;
      });
    }
  }

  /** DFS-1821: true when MyDrop already has this subscription menu pack. */
  isSubscriptionActive(menuPackId: number): boolean {
    return isSubscriptionMenuPackActive(menuPackId, this.myDrop?.Subscriptions);
  }

  openBenefitsPopup(itemId: number = 0) {
    if (this.isSubscriptionActive(itemId)) {
      return;
    }

    this.selectedItemId = itemId;
    this.redirectTo = "/purchase?selectedItemId=" + itemId;
    if(this.memberId == 0)
    {
      this.loginPopup.open(null, this.phoneNumber, 'phone', this.redirectTo);
      return;
    }
    var registrationCompletedSteps = this.authService.getProp('registrationCompletedSteps');
    if (registrationCompletedSteps && !Utils.hasStepCompleted(registrationCompletedSteps, 'profile')) {
        this.loginTitle = 'Complete your profile';
        this.loginDescription = 'Complete your profile to access all features.';
        this.loginPopup.open(null, this.phoneNumber, 'register', this.redirectTo);
        return;
    }

    this.selected = true;
    if(itemId == 0)
    {
      this.selected = false;
      return;
    }
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id == itemId);
    if(menuPack)
    {
      const pack = this.currencyMeta.Packs.find(p => p.Id == menuPack.PackId);
      if(pack)
      {
        if(pack.Benefits.length == 0)
        {
          if(menuPack.IsSubscription)
          {
            const menuPacks = this.filteredMenuPacks.filter(cc => cc.ParentId === menuPack.Id);
            if(menuPack.ParentId > 0 || menuPacks.length > 0)
              this.openChoosePlanPopup(itemId);
          }
          this.openCheckoutPopup(itemId);
        } else {
          const modalRef = this.modalService.open(BenefitsComponent, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'lg',
            centered: false,
            windowClass: 'checkout-popup-wrapper',
            modalDialogClass: 'checkout-popup',
            fullscreen: window.innerWidth <= 768,
          });

          var purchase = this.createPurchaseObject(itemId);
          //Passing itemIds to popup
          modalRef.componentInstance.purchase = purchase;
          modalRef.componentInstance.currencyMeta = this.currencyMeta;
          modalRef.componentInstance.myDrop = this.myDrop;

          //Retrieving MemberCurrency from popup
          modalRef.result.then((result: boolean) => {
            if (result) {
              this.logService.debug("purchase details:", result);
              // Redirect to the redirectTo URL if it exists
              if (this.redirectTo) {
                this.router.navigateByUrl(this.redirectTo);
              } else {
                this.router.navigate(['/purchase']);
              }
            }
          }).finally(() => {
            this.selected = false;
          });
        }
      } else {
        this.selected = false;
      }
    } else {
      this.selected = false;
    }
  }

  openChoosePlanPopup(itemId: number = 0) {
    this.selected = true;
    if(itemId == 0)
    {
      this.selected = false;
      return;
    }

    const modalRef = this.modalService.open(ChoosePlanComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: false,
      windowClass: 'checkout-popup-wrapper',
      modalDialogClass: 'checkout-popup',
      fullscreen: window.innerWidth <= 768,
    });

    var purchase = this.createPurchaseObject(itemId);

    //Passing itemIds to popup
    modalRef.componentInstance.purchase = purchase;
    modalRef.componentInstance.currencyMeta = this.currencyMeta;
    modalRef.componentInstance.myDrop = this.myDrop;

    //Retrieving MemberCurrency from popup
    modalRef.result.then((result: boolean) => {
      if (result) {
        this.logService.debug("purchase details:", result);
        // Redirect to the redirectTo URL if it exists
        if (this.redirectTo) {
          this.router.navigateByUrl(this.redirectTo);
        } else {
          this.router.navigate(['/purchase']);
        }
      }
    }).finally(() => {
      this.selected = false;
    });
  }

  openCheckoutPopup(itemId: number = 0) {
    // Shared gate for Select, selectedItemId, short_code, and PaymentLink invite_code.
    // Payment links intentionally use the same owned-pack rule (no override).
    if (!shouldOpenCheckoutForMenuPack(itemId, this.myDrop?.Subscriptions)) {
      this.selected = false;
      return;
    }

    const packInCatalog =
      (this.menuPacks ?? []).some((mp) => mp.Id === itemId) ||
      (this.filteredMenuPacks ?? []).some((mp) => mp.Id === itemId);
    if (!packInCatalog) {
      this.selected = false;
      this.alertService.error('This plan is not available.');
      return;
    }

    if (this.checkoutModalOpen) {
      // Deep-link may have set selected=true; don't leave Select disabled.
      this.selected = false;
      return;
    }

    this.selectedItemId = itemId;
    this.redirectTo = "/purchase?selectedItemId=" + itemId;
    if(this.memberId == 0)
    {
      // Deep-link may have set selected=true; clear so Select stays usable.
      this.selected = false;
      this.loginPopup.open(null, this.phoneNumber, 'phone', this.redirectTo);
      return;
    }
    var registrationCompletedSteps = this.authService.getProp('registrationCompletedSteps');
    if (registrationCompletedSteps && !Utils.hasStepCompleted(registrationCompletedSteps, 'profile')) {
        this.loginTitle = 'Complete your profile';
        this.loginDescription = 'Complete your profile to access all features.';
        // Deep-link may have set selected=true; clear so Select stays usable.
        this.selected = false;
        this.loginPopup.open(null, this.phoneNumber, 'register', this.redirectTo);
        return;
    }

    this.selected = true;
    this.checkoutModalOpen = true;

    try {
      const modalRef = this.modalService.open(this.checkoutComponent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        centered: false,
        windowClass: 'checkout-popup-wrapper',
        modalDialogClass: 'checkout-popup',
        fullscreen: window.innerWidth <= 768,
      });

      var purchase = this.createPurchaseObject(itemId);

      //Passing itemIds to popup
      modalRef.componentInstance.purchase = purchase;
      modalRef.componentInstance.currencyMeta = this.currencyMeta;
      modalRef.componentInstance.myDrop = this.myDrop;

      // Keep Select disabled until the modal settles. Dismissal rejects result —
      // catch it so finally still runs without an unhandled rejection.
      modalRef.result
        .then((result: boolean) => {
          if (result) {
            this.logService.debug("purchase details:", result);
            // Redirect to the redirectTo URL if it exists
            if (this.redirectTo) {
              this.router.navigateByUrl(this.redirectTo);
            } else {
              this.router.navigate(['/purchase']);
            }
          }
        })
        .catch(() => {
          // User dismissed the modal (NgbModal rejects on dismiss).
        })
        .finally(() => {
          this.selected = false;
          this.checkoutModalOpen = false;
        });
    } catch (err) {
      // open()/setup failures must not leave checkoutModalOpen wedged.
      this.selected = false;
      this.checkoutModalOpen = false;
      this.logService.error('Failed to open checkout', err);
      this.alertService.error('Unable to open checkout. Please try again.');
    }
  }

  getMenuPackNameById(menuPackId: number)
  {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const formattedText = Utils.newLineToBr(menuPack.Name, this.sanitizer);
      return formattedText;
    }
    return "";
  }

  getPackDescriptionById(packId: number)
  {
    const pack = this.currencyMeta.Packs.find(p => p.Id === packId);
    if(pack)
    {
      const formattedText = Utils.newLineToBr(pack.Description, this.sanitizer);
      return formattedText;
    }
    return "";
  }

  getPackExpiryLabel(menuPackId: number)
  {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      return "Expires in " + menuPack.TermDuration + " " + Utils.getEnumNameFromValue(TermUnit, menuPack.TermUnit) + (menuPack.TermDuration > 1 ? "s" : "");
    }
    return "";
  }

  hasActiveMenuPacks(categoryMenuPack: any): boolean {
    return Array.isArray(categoryMenuPack?.MenuPacks) && categoryMenuPack.MenuPacks.some((c: any) => c && c.State === 1);
  }

  getPackImage(menuPackId: number)
  {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const pack = this.currencyMeta.Packs.find(p => p.Id === menuPack.PackId);
      return pack?.Image;
    }
    return "";
  }

  getTermDuration(menuPackId: number) {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      return "per " + Utils.getEnumNameFromValue(TermUnit, menuPack.TermUnit).toLowerCase();
    }
    return "";
  }

  getPerClassPrice(menuPackId: number) {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if (menuPack) {
      const currency = this.currencyMeta.Currencies.find(p => p.Id === menuPack.CurrencyId);
      const scale = currency?.Scale || 1;
      const pack = this.currencyMeta.Packs.find(p => p.Id === menuPack.PackId);
      if (pack) {
        const price = (menuPack.Price * scale) / pack.Quantity / 100;
        return "$" + price.toFixed(2) + " per " + currency?.ProductUnit;
      }
    }
    return "";
  }


  async onLocationChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.locationId = parseInt(select.value, 10);
    this.persistSelectedLocation();
    if (this.memberId === 0 && this.locationId > 0) {
      this.currencyMeta = await this.metaService.getCurrencyMetaByLocation(this.locationId);
      this.buildCategoryMenuPacks();
    }
  }

  private resolveInitialLocationId(): number {
    if (this.locationId > 0 && this.isValidLocationId(this.locationId)) {
      return this.locationId;
    }

    const storedLocation = this.localStorageService.getProperty<Location>(
      'location',
      'selectedLocation'
    );
    if (storedLocation?.Id > 0 && this.isValidLocationId(storedLocation.Id)) {
      return storedLocation.Id;
    }

    if (this.memberId > 0 && this.member?.LocationId > 0 && this.isValidLocationId(this.member.LocationId)) {
      return this.member.LocationId;
    }

    return this.locations?.length ? this.locations[0].Id : 1;
  }

  private isValidLocationId(locationId: number): boolean {
    return this.locations.some((location) => location.Id === locationId);
  }

  private persistSelectedLocation(): void {
    const location = this.locations.find((loc) => loc.Id === this.locationId);
    if (location) {
      this.localStorageService.setLocation(location);
    }
  }

  ngOnDestroy() {
    
  }

  loggedIn(isLoggedIn: boolean) {
    if (isLoggedIn)
    {
      window.location.reload();
      //this.currentMember = this.authService.getLoggedInMember();
    }
  }

  getShortLinkMetaDataByKey(shortLink: ShortLink, key: string): ShortLinkMeta | undefined {
    const metaData = shortLink.MetaData.find(meta => meta.Key === key);
    return metaData;
  }

  createPurchaseObject(itemId: number) : Purchase {
    const addOnIds = this.currencyMeta.MenuPackAddons
      .filter(a => a.MenuPackId === itemId)
      .map(a => a.AddonMenuPackId);

    if(!addOnIds.includes(itemId))
    {
      addOnIds.push(itemId);
    }

    const itemsToPurchase = [
      ...this.filteredMenuPacks.filter(mp => addOnIds.includes(mp.Id)),
      ...this.menuPacks.filter(mp => addOnIds.includes(mp.Id) && !this.filteredMenuPacks.some(fmp => fmp.Id === mp.Id))
    ];

    // Override StartOffset and StartRule if item is present in addOns
    for (var item of itemsToPurchase) {
      const addon = this.currencyMeta.MenuPackAddons.find(a => a.MenuPackId === itemId && a.AddonMenuPackId === item.Id);
      if (addon) {
        item.StartOffset = Number(addon.StartOffset);
        item.StartRule = addon.StartRule;
      }
    }
    
    // Attach Pack to each item in itemsToPurchase
    for (const item of itemsToPurchase) {
      const foundPack = this.currencyMeta.Packs.find(p => p.Id === item.PackId);
      if (foundPack) {
        item.Pack = foundPack;
      }
      if (item.Id !== itemId) {
        const mainPack = this.currencyMeta.Packs.find(p => p.Id === this.filteredMenuPacks.find(mp => mp.Id === itemId)?.PackId);
        if (mainPack && item.Pack) {
          item.Pack.Image = mainPack.Image;
        }
      }
    }

    let openingDate: Date;
    const locationOpeningDate = this.locations.find(c => c.Id === this.locationId)?.OpeningDate;
    if (locationOpeningDate) {
      openingDate = new Date(locationOpeningDate);
    } else {
      openingDate = new Date(1, 1, 1);
    }

    var purchase : Purchase = {
      MemberId: this.memberId,
      MainItemId: itemId,
      LocationId: this.locationId,
      OpeningDate: openingDate,
      Items:itemsToPurchase,
      Subtotal: 0,
      SalesTax: 0,
      ProcessingFeeRate: 0,
      ProcessingFeeAmount: 0,
      Total: 0
    };

    return purchase;
  }
}
